import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import MessageType from '../../enums/MessageType';
import Message from '../../v2/components/ui/Message/Message';
import Translation from '../../v2/lang/Translation';
import replaceHTMLEntityWithSymbol from '../../v2/utils/replace-html-entity-with-symbol';

const useStyles = createUseStyles({
  rewardsPointsMessage: {
    marginBottom: '1em',
  },
});

export function RewardsPointsMessage(props) {
  const classes = useStyles();
  
  if (!props.rewardPointsApplied) return null;
  
  const {spent, discountAmountDisplayString} = props.rewardsPoints;
  
  return (
    <div className={classes.rewardsPointsMessage} data-test="RewardsPointsMessage">
      <Message type={MessageType.SUCCESS}>
        <Translation placeholderValues={[spent, replaceHTMLEntityWithSymbol(discountAmountDisplayString)]}>
          youve.used.x.rewards.points
        </Translation>
      </Message>
    </div>
  );
}

const mapStateToProps = state => ({
  rewardsPoints: state.start.order.rewardPoints || {},
  rewardPointsApplied: state.start.order.rewardPoints && state.start.order.rewardPoints.spent > 0,
});

RewardsPointsMessage.propTypes = {
  rewardsPoints: PropTypes.shape({
    spent: PropTypes.string.isRequired,
    discountAmountDisplayString: PropTypes.string.isRequired,
  }),
  rewardPointsApplied: PropTypes.bool,
};

export default connect(
  mapStateToProps,
)(RewardsPointsMessage);
